import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { FormElement, TextAreaInput, TimeInput, DateInput } from 'b3';
import { Motion, spring } from 'react-motion';
import { openModal } from '../../actions/ModalActions';
import ContactCardDropdown from '../../components/contact-card/ContactCardDropdown';
import { goToStep, updateCallData, goToFollowUpCallStep } from './logActivityReducer';
import TimeDurationInput from './TimeDurationInput';

@connect(
    state => ({
        contacts: state.activeClient.contacts,
        client: state.activeClient.client,
        date: state.logActivityWizard.callData.date,
        participatingContactId: state.logActivityWizard.callData.participatingContactId,
        notes: state.logActivityWizard.callData.notes,
        actionStepIndex: state.logActivityWizard.actionStepIndex
    }),
    { openModal, goToStep, updateCallData, goToFollowUpCallStep }
)
export default class LogCallStep extends React.Component {
    state = {
        date: moment(),
        fadeDown: false
    };
    componentDidMount() {
        if(document.activeElement && document.activeElement.tagName !== 'TEXTAREA') {
            this.textInput.focus();
        }
    }
    isValid() {
        return !! this.props.participatingContactId;
    }
    handleContactChange(participatingContactId) {
        this.props.updateCallData({participatingContactId});
    }
    handleUserContacted = () => {
        this.props.goToStep('ConversationStep');
    }
    handleNoAnswer = () => {
        this.props.updateCallData({noAnswer: true});
        this.props.goToFollowUpCallStep();
    }
    handleLeftMessage = () => {
        this.props.updateCallData({
            leftMessage: true
        });
        this.props.goToFollowUpCallStep();
    }
    handleNoteTextChange = (notes) => {
        this.props.updateCallData({notes});
    }
    updateDate = (date) => {
        this.props.updateCallData({date});
    }
    render() {
        var { date, contacts, participatingContactId, client, notes, actionStepIndex } = this.props;

        return (
            <div className="wizard-step-wrapper">
                <div className="form-row">
                    <h2>
                        Call notes
                    </h2>
                    <div>
                        <TextAreaInput
                            ref={el => this.textInput = el}
                            rows={3}
                            placeholder="Enter the call notes"
                            value={notes} 
                            onChange={this.handleNoteTextChange} />
                    </div>
                </div>

                <div style={{height: 1, background: '#BDD1DD', marginTop: 20}}></div>

                <h2 style={{marginBottom: 15}}>Who did you talk to?</h2>
                <ContactCardDropdown
                    selectedContactId={participatingContactId}
                    onChange={this.handleContactChange.bind(this)}
                    contacts={contacts}
                    clientId={client.id} />

                {actionStepIndex > 0 &&
                    <Motion 
                        defaultStyle={{
                            marginTop: -40, 
                            opacity: 0,
                        }} 
                        style={{
                            marginTop: spring(0), 
                            opacity: spring(1), 
                        }}>
                    {({marginTop, opacity}) =>
                        <div style={{marginTop, opacity, height: 110 - marginTop}}>
                            <div className="schedule-date-time-picker">
                                <div>
                                    <h2>Time</h2>
                                    <FormElement icon="clock-2">
                                        <TimeInput
                                            value={date}
                                            onChange={this.updateDate}
                                        />
                                    </FormElement>
                                </div>
                                <div className="date-picker-wrapper">
                                    <h2>Date</h2>
                                    <FormElement icon="calendar-2" style={{minWidth: 160}}>
                                        <DateInput
                                            submitOnChangeOnly={true}
                                            value={date}
                                            onChange={this.updateDate}
                                        />
                                    </FormElement>
                                </div>
                                <div style={{flex: 1}}>
                                    <h2>Duration</h2>
                                    <TimeDurationInput />
                                    
                                </div>
                            </div>
                        </div>
                    }
                    </Motion>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/schedule-wizard/LogCallStep.js